/*  ========================================================================
    # Scripts - Appointment Modal
    ========================================================================  */

/**
 * Script that handles the appointment modal trigger to open Dr Flex appointments.
 */
const AppointmentModal = {
  cfg: {
    triggerSelector: '[data-toggle="appointment-modal"]',
    triggers: document.querySelectorAll('[data-toggle="appointment-modal"]')
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.triggers && this.cfg.triggers.length > 0) {
      // Use event delegation so dynamically rendered elements are also captured
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest(this.cfg.triggerSelector);

        if (trigger) {
          event.preventDefault();
          if (typeof toggleDrFlexAppointments === 'function') {
            toggleDrFlexAppointments();
          }
        }
      });
    }
  }
};

export default AppointmentModal;
